import React from "react";
import styles from "./HeroM.module.css";

export default function Header() {
  return <div className={styles.sectionContent} id="hero">
      <div className={styles.leftContent}>
        <div className={styles.sectionTitle}>
          <h2>
            <strong>Naprawa Twojego auta</strong> to dla nas przyjemność
          </h2>
        </div>
        <div className={styles.headerLinks}>
          <a href="#services">Zapoznaj się z ofertą</a>
          <a href="#faq">Sprawdź najczęściej zadawane pytania</a>
        </div>
      </div>
      <div className={styles.rightContent}>
        <img src={`${process.env.PUBLIC_URL}/Images/Logo.webp`} alt="Logo" className={styles.logo} />
      </div>
    </div>;
}
